<template>
  <div id="app">
    <NavigationBar />
    <main class="main-content" :class="{ 'interior-page': !isHomePage }">
      <RouterView />
    </main>
    <SiteFooter v-if="!isHomePage" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import NavigationBar from '@/components/NavigationBar.vue'
import SiteFooter from '@/components/SiteFooter.vue'

const route = useRoute()
const isHomePage = computed(() => route.path === '/')
</script>

<style scoped>
#app {
  min-height: 100vh;
  min-height: 100dvh; /* dynamic vh: on mobile, 100vh counts the retracted browser
                         chrome and forces #app taller than the visible screen —
                         that extra height is the black gap below the home hero.
                         dvh matches the actually-visible viewport. */
  background: #000000;
  color: white;
  /* Sticky-footer column: main-content grows to fill, so SiteFooter is pushed to
     the bottom of the viewport on short pages, yet still flows normally (no
     overlap) when content is taller than the screen. */
  display: flex;
  flex-direction: column;
}

.main-content {
  background: #000000;
  flex: 1 0 auto; /* take the slack so the footer sits at the viewport bottom */
}

.interior-page {
  padding-top: 70px;
}
</style>
